import { createFileRoute } from '@tanstack/react-router'
import { BotAccessControl } from '~/features/bots/components/BotAccessControl'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/settings/access-control')({
  component: Component,
})

function Component() {
  const { botId, workspaceId } = Route.useParams()
  const { user: currentUser } = Route.useRouteContext()
  return <BotAccessControl workspaceId={workspaceId} botId={botId} currentUser={currentUser} />
}
